import { Fragment } from "react";
import { usePopup } from "../../../context";
import { EventName, postEvent } from "../../../dropin/events";
import { BankText } from "../../bank";
import { Spacer } from "../../components/spacer";
import { AshButton, MaxWidthWrapper } from "../../popup";
import { H3 } from "../../ussd";
import { Image } from "../../nav";
import { useSentMoney } from "../../../hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import changePaymentIcon from "../../../assets/convertshape-2.svg";

export const CountDownExpiration = () => {
  const { options, isConfirmClicked, setIsConfirmClicked, setPosition } =
    usePopup();

  const { loading, onClick } = useSentMoney();

  const onClose = async () => {
    if (options.onExit) {
      options.onExit({});
    }
    postEvent({
      target: window.parent,
      event: {
        name: EventName.EXIT,
        payload: {
          message: isConfirmClicked
            ? "Timeout occurred before transaction confirmation"
            : "Timeout occurred without user taking payment action",
          code: isConfirmClicked ? "01" : "02",
        },
      },
    });
  };

  // const

  return (
    <Fragment>
      <ReversalSelectWrapper>
        <FlexRow>
          <H3>Countdown Expired</H3>
          <Spacer height={40} />
          <FontAwesomeIcon
            style={{ color: "orange", fontSize: "20px" }}
            icon={faTriangleExclamation}
          />
        </FlexRow>
        <BankText>
          <b>
            {" "}
            Your payment could not be verified because the window for order
            payment has closed, and payment had not yet been received.
          </b>
        </BankText>
        <Spacer height={20} />
        <BankText>
          <b>
            If you have made payment, expect a reversal and freely contact{" "}
            {options?.customer_service_channel} should need arise.
          </b>
        </BankText>
        <Spacer height={20} />
        <Spacer height={16} />

        <MaxWidthWrapper>
          <AshButton
            onClick={() => {
              onClose();
            }}
          >
            <div>Close This Screen </div>
          </AshButton>
        </MaxWidthWrapper>
        <Spacer height={16} />
        <MaxWidthWrapper>
          <AshButton
            onClick={() => {
              postEvent({
                target: window.parent,
                event: {
                  name: EventName.RELOAD,
                  payload: {},
                },
              });
            }}
          >
            <Image src={changePaymentIcon} alt="close-payment-btn" />{" "}
            <div>Refesh This Browser Tab</div>
          </AshButton>
        </MaxWidthWrapper>
      </ReversalSelectWrapper>
    </Fragment>
  );
};

export const ReversalSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 292px;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  column-gap: 5px;
`;
